var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 200,
    x2: 100,
    y2: -1.818989e-12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F51A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1172BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M93.4,131.8l26.1,26.1c1.4,1.4,3.2,2.1,5.1,2.1c1.9,0,3.8-0.8,5.1-2.1l26.1-26.1l-10.2-10.2 l-13.8,13.8V47.1h-14.5v88.2l-13.8-13.8L93.4,131.8z M68.1,64.6v88.2h14.5V64.6l13.8,13.8l10.2-10.2L80.5,42 c-1.4-1.4-3.2-2.1-5.1-2.1s-3.8,0.8-5.1,2.1L44.1,68.2l10.2,10.2L68.1,64.6z M195,5c-3-3.2-7.3-5-11.7-5H16.7C12.3,0,8,1.8,5,5 c-3.2,3-5,7.3-5,11.7v166.7c0,4.4,1.8,8.6,5,11.7c3,3.2,7.3,5,11.7,5h166.7c9.1-0.2,16.4-7.6,16.7-16.7V16.7C200,12.3,198.2,8,195,5 z M183.3,183.3H16.7V16.7h166.7V183.3z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdown);
export default __webpack_public_path__ + "static/media/updown.ca02631bfd97ae10054686ee3c7c6de8.svg";
export { ForwardRef as ReactComponent };